module.exports = __webpack_public_path__ + "img/06-livepen-info.2e9d12ba.png";